import store from "@/store";
import useJwt from "./useJwt";

// Integration between JWT auth and Vuex user module
export const setupJwtIntegration = () => {
  const token = store.state.user.token;

  // If user is already logged in (token exists in Vuex), set it to JWT service
  if (token) {
    useJwt.setToken(token);
  }
};

// Helper to sync JWT login with Vuex user module
export const handleJwtLogin = (response) => {
  const { userData, accessToken } = response.data;

  // Set tokens in JWT service
  useJwt.setToken(accessToken);
  if (response.data.refreshToken) {
    useJwt.setRefreshToken(response.data.refreshToken);
  }

  // Save user data in localStorage for JWT compatibility
  localStorage.setItem("userData", JSON.stringify(userData));

  // Parse forms data if it exists
  // const userRights = userData.ability || [];

  // // Update Vuex store
  // store.dispatch("user/login", {
  //   token: accessToken,
  //   user: userData,
  //   userRights,
  // });

  return userData;
};

// Helper to handle logout
export const handleJwtLogout = () => {
  // Remove JWT tokens
  localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
  localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
  localStorage.removeItem("userData");

  // Clear Vuex state
  store.dispatch("user/logout");
};

export default {
  setupJwtIntegration,
  handleJwtLogin,
  handleJwtLogout,
};
